export default __webpack_public_path__ + "media/images/table_dirty-61f689c2f2fb63175fe413d205aac881.png";